import { generateScenarioFileUrl } from '@/utils/generateScenarioFileUrl';
import styles from './index.module.scss';

export type CharacterProps = {
  character?: string | null;
};

export const Character: React.FC<CharacterProps> = ({ character }) => {
  if (!character) {
    return null;
  }

  return (
    <div className={styles.character}>
      <img src={generateScenarioFileUrl(character, 'character')} alt="" />
    </div>
  );
};
